import { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { register } from '../../actions/auth';

const Register = () => {

    const dispatch = useDispatch();

    const { isAuthenticated } = useSelector(state => state.auth);

    const [registerData, setRegisterData] = useState({
        nombre: null,
        apellido_paterno: null,
        apellido_materno: null,
        email: null,
        password: null
    });

    /* Register */
    const onChange = (e) => {
        setRegisterData({
            ...registerData,
            [e.target.name]: e.target.value
        })
    }

    const handleKeyPressRegister = (e) => {
        if(e.keyCode === 13){
            submitRegister();
        }
    }

    const submitRegister = () => {
        dispatch(register(registerData));
    }

    /* Funciones generales */
    const onViewPassword = (origen) => {
        let registerInputType = document.getElementById(origen).type;
        
        if(registerInputType == 'password')document.getElementById(origen).type = 'text';
        else document.getElementById(origen).type = 'password';
    }

    useEffect(() => {
        if(isAuthenticated){
            window.location.href = '/dashboard';
        }
    }, [isAuthenticated]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        body{
                            background-color: #312803;
                        }
                        
                        .centradoVertical {
                            margin: 0;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                        
                        .logoHeader {
                            height: 5vw;
                            min-height: 80px;
                            max-height: 100px;
                            margin-bottom: 25px;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <div className="row">
                <div className="col-md-6 offset-md-3 centradoVertical">
                    <div className="card bg-light"> 
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12 text-center mb-3">
                                    <img src={process.env.REACT_APP_PUBLIC_ROUTE + '/assets/images/logo-color.png'} className="d-inline-block logoHeader" alt="logo"/>
                                    <h5 className="card-title">Crear cuenta</h5>
                                </div>

                                <div className="col-md-12">
                                    <div className="input-group mb-3">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={registerData.nombre || ''} onChange={e => onChange(e)} onKeyDown={handleKeyPressRegister}></input>
                                            <label htmlFor="nombre">Nombre</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="input-group mb-3">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" placeholder="Apellido paterno" id="apellido_paterno" name="apellido_paterno" value={registerData.apellido_paterno || ''} onChange={e => onChange(e)} onKeyDown={handleKeyPressRegister}></input>
                                            <label htmlFor="apellido_paterno">Apellido paterno</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="input-group mb-3">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" placeholder="Apellido materno" id="apellido_materno" name="apellido_materno" value={registerData.apellido_materno || ''} onChange={e => onChange(e)} onKeyDown={handleKeyPressRegister}></input>
                                            <label htmlFor="apellido_materno">Apellido materno</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="input-group mb-3">
                                        <div className="form-floating">
                                            <input type="email" className="form-control" placeholder="Correo" id="email" name="email" value={registerData.email || ''} onChange={e => onChange(e)} onKeyDown={handleKeyPressRegister}></input>
                                            <label htmlFor="email">Correo</label>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-md-6">
                                    <div className="input-group mb-3">
                                        <div className="form-floating">
                                            <input type="password" id="password" className="form-control" placeholder="Contraseña" name="password" value={registerData.password || ''} onChange={e => onChange(e)} onKeyDown={handleKeyPressRegister}></input>
                                            <label htmlFor="password">Contraseña</label>
                                        </div>
                                        <div className="input-group-append">
                                            <button className="btn btn-primary viewPassword" onClick={() => onViewPassword('password')}><i className="fa-solid fa-eye"></i></button>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-group mt-3 text-center">
                                        <button type="button" className="btn btn-primary w-100" onClick={() => submitRegister()}>Crear cuenta</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Register;